// extracted by mini-css-extract-plugin
module.exports = {"CcxSectionHeader":"CcxSectionHeader_JBoUa"};